import { UserSettingsT, useUserContext } from "../context";

const useUserSettings = (): UserSettingsT => {
  const [state] = useUserContext();

  return state?.settings;
};

export default useUserSettings;
